<a class="skip-link" href="#main-content" (click)="skipToMainContent($event)">{{ 'unifiedShell.skipToContent' | translate }}</a>
<app-custom-loader></app-custom-loader>
<app-alert *ngFor="let session of currentSessions; let i = index" [index]="i + 1" [title]="session.title"></app-alert>

<app-digital-stamp *ngIf="unified && !isContent && identityModel.dgaRegistrationNumber?.trim()"
  [registrationNumber]="identityModel.dgaRegistrationNumber" [certificateUrl]="identityModel.dgaCertificateUrl"></app-digital-stamp>
<app-nav [style.direction]="isRtl ? 'rtl': 'ltr'" *ngIf="!isLogin" [title]="title" [isContent]="isContent"
  [courseLink]="courseLink" (showSearch)="isSearch = $event" [hideSearch]="isSearch"></app-nav>
<app-breadcrumb *ngIf="unified && showBreadcrumb"></app-breadcrumb>
<main id="main-content" class="main-content" tabindex="-1">
  <div class="custom-layout">
    <router-outlet></router-outlet>
    <app-search id="portal-search" [showSearch]="isSearch" (hideSearch)="isSearch = $event"></app-search>
  </div>
  <app-page-feedback *ngIf="showPageFeedback"></app-page-feedback>
</main>
<app-footer *ngIf="!isContent && !isLogin"></app-footer>
<app-audio-player [stopAudioPlayer]="isContent"></app-audio-player>